var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"download-button"},[_c('burp-button',_vm._b({class:_vm.css,attrs:{"icon":_vm.iconName},on:{"click":_vm.download}},'burp-button',{message: _vm.message,title: _vm.title,text: _vm.text},false),[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }